<template>
    <Pagination
        v-if="!['kanban'].includes(viewData.layout) && !viewData.workflowcard_id"
        :id="PAGE_KEY"
        :pagination_key="PAGE_KEY"
        :pagination_total="settings.total"
        :pagination_limit="settings.limit"
        :pagination_current="settings.current"
        @updatePage="handlePagination"
    />
</template>

<script>
import { defineComponent, inject, reactive, computed } from "vue";
import { useRoute } from "vue-router";

import trans from "helpers/_translation";

import Pagination from "components/pagination";

export default defineComponent({
    name: "part",
    components: {
        Pagination
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");

        const PAGE_KEY = inject("PAGE_KEY");
        const settings = inject("overviewSettings");
        const handlePagination = inject("handlePagination");

        return {
            trans,
            route,
            viewData,

            PAGE_KEY,

            settings,

            handlePagination
        }
    }
});
</script>
<script setup>
</script>